import React from 'react';
import type { ViewMode } from './types';

import { useTranslation } from 'react-i18next';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

export const ViewModeToggle: React.FC<ViewModeToggleProps> = React.memo(
  ({ viewMode, onViewModeChange }: ViewModeToggleProps) => {
    const { t } = useTranslation('pleri/chat');
    const segments: { mode: ViewMode; label: string }[] = [
      { mode: 'result', label: t('result') },
      { mode: 'debug', label: t('inspect') },
    ];

    return (
      <div className="flex items-center rounded-md bg-gray-100/80 p-0.5 dark:bg-gray-800/60">
        {segments.map(({ mode, label }) => {
          const isActive = viewMode === mode;
          return (
            <button
              key={mode}
              onClick={() => onViewModeChange(mode)}
              className={
                isActive
                  ? 'rounded-[5px] bg-white px-2.5 py-1 text-xs font-medium text-gray-900 shadow-sm dark:bg-gray-700 dark:text-gray-100'
                  : 'rounded-[5px] px-2.5 py-1 text-xs font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
              }
            >
              {label}
            </button>
          );
        })}
      </div>
    );
  },
);

ViewModeToggle.displayName = 'ViewModeToggle';
